export default __webpack_public_path__ + "static/media/dealedge3.72fbc99c.png";